import React, { useEffect, useState } from 'react';
import Toast from '../../Components/Common/Modules/Toast';
import LoadingSpinner from '../../Helpers/LoadingSpinner';
import useGuardarCobranzaRechazo from '../../Hooks/useGuardarCobranzaRechazo';
import useIniciarCambioInstrumentoDeCobro from '../../Hooks/useIniciarCambioInstrumentoDeCobro';
import useCambioInstrumentoDeCobro from '../../Hooks/useCambioInstrumentoDeCobro';
import WondersoftIframe from './WondersoftIframe';
import ErrorBoundary from '../../Components/Common/Organism/ErrorBoundary';
import useGuardarRtaWondersoft from '../../Hooks/useGuardarRtaWondersoft';
import { getPrepagoModel } from '../../Components/Features/Pagos/getPrePagoModel';
import usePrePagoPendiente from '../../Hooks/usePrePagoPendiente';

const IframeTarjeta = (props) => {
    const [dataIframe, error, isLoading, getUrlPagosPendientes] = useGuardarCobranzaRechazo(props.deudas, props.tarjeta, props.idAbandonoCobranza); //devuelve url iframe pagos pendientes
    const [dataNuevaTarjeta, errorNuevaTarjeta, isLoadingNuevaTarjeta, getUrlCambioFormaDePago] = useIniciarCambioInstrumentoDeCobro(); //devuelve url iframe cambioformadepago
    const [dataCambioFormaDePago, errorCambioFormaDePago, isLoadingCambioFormaDePago, cambiarFormaDePago] = useCambioInstrumentoDeCobro();
    const [dataRta, errorRtaWs, isLoadingRtaWs, guardarRtaWs] = useGuardarRtaWondersoft();
    const deudasComplete = props.deudasCompletas;
    const payloadNuevaTarjeta = props.payloadNuevaTarjeta;
    const suscripcionesFormDePago = props.suscripciones;
    const idAbandonoCobranza = props.idAbandonoCobranza;
    const iframeHeight = props.iframeHeight;
    const [errorPagoWS, setErrorPagoWS] = useState(false);
    const [showToastErrorPagoWS, setShowToastErrorPagoWS] = useState(false);
    const [mensaje, setMensaje] = useState();
    const data = { ...dataIframe, deudasComplete, setErrorPagoWS, setMensaje, idAbandonoCobranza, guardarRtaWs };
    const nuevaTarjeta = props.nuevaTarjeta;
    const dataFormaDePago = { ...dataNuevaTarjeta, nuevaTarjeta, cambiarFormaDePago, payloadNuevaTarjeta, suscripcionesFormDePago };
    const [errorPrePago, savePrePago] = usePrePagoPendiente();

    const prePago = !nuevaTarjeta ? getPrepagoModel(props?.deudas, props?.tarjeta, idAbandonoCobranza) : null;

    useEffect(() => {
        if (!nuevaTarjeta) {
            iniciarPagos();
        } else {
            getUrlCambioFormaDePago();
        }
    }, [errorPagoWS]);

    const iniciarPagos = () => {
        if (!errorPagoWS) {
            props.showImport(true);
            savePrePago(prePago);
            getUrlPagosPendientes(props.deudas, props.tarjeta, props.idAbandonoCobranza);
        } else {
            props.showImport(false);
            setShowToastErrorPagoWS(true);
            setErrorPagoWS(false);
        }
    };

    return (
        <section>
            <LoadingSpinner withBody isLoading={isLoading || isLoadingNuevaTarjeta || isLoadingCambioFormaDePago || isLoadingRtaWs}>
                <ErrorBoundary error={error || errorNuevaTarjeta || errorCambioFormaDePago}>
                    {showToastErrorPagoWS && (
                        <Toast
                            status={'warning'}
                            title="¡Ups!"
                            type={'toast'}
                            value={showToastErrorPagoWS}
                            closeAuto={true}
                            close
                            className="--roboto"
                            changeValue={() => setShowToastErrorPagoWS(false)}
                        >
                            {mensaje}
                        </Toast>
                    )}
                    {!errorPagoWS && (
                        <>
                            {error || errorNuevaTarjeta ? ( //si fallan los servicios para obtener URL de ws
                                error ? (
                                    <Toast status="warning" title={error} />
                                ) : (
                                    <Toast status="warning" title={errorNuevaTarjeta} />
                                )
                            ) : (
                                <WondersoftIframe dataWondersoft={nuevaTarjeta ? dataFormaDePago : data} iframeHeight={iframeHeight} />
                            )}
                        </>
                    )}
                </ErrorBoundary>
            </LoadingSpinner>
        </section>
    );
};

export default IframeTarjeta;
